import { __rest as t } from "../../_virtual/_tslib.js";
import { jsx as e } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import { InputField as s } from "@vds-core/inputs";
var a = r(function (r, a) {
  var i = r.type,
    n = t(r, ["type"]);
  switch (i) {
    case "number":
    case "text":
    case "inlineAction":
    case "password":
    case "creditCard":
    case "tel":
    case "date":
    case "securityCode":
      return e(s, Object.assign({
        type: i
      }, n, {
        inputRef: a
      }));
    default:
      return console.warn("Warning: Native input type ".concat(i, " is not supported")), e(s, Object.assign({
        type: "text"
      }, n, {
        inputRef: a
      }));
  }
});
a.defaultProps = {
  type: "text"
};
export { a as default };